import { render, staticRenderFns } from "./ElColor.vue?vue&type=template&id=7769acf0&"
import script from "./ElColor.vue?vue&type=script&lang=ts&"
export * from "./ElColor.vue?vue&type=script&lang=ts&"
import style0 from "./ElColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports